import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../utils';


@Component({
  selector: 'app-pin-modal',
  templateUrl: './pin-modal.component.html',
  styleUrls: ['./pin-modal.component.css']
})
export class PinModalComponent implements OnDestroy {

  // Pass the pin verification function in as an argument to avoid a circular
  // dependency between this and ApiService.
  @Input() verifyPinFunction: (pin: string) => Promise<void>;
  // A function which is called when a pin is submitted and verified.
  @Input() pinCallback: (pin: string) => undefined;
  // A function which is called when the modal is closed (including after
  // pinCallback is called due to a successful pin).
  @Input() closedCallback: () => undefined;

  public pinInput = '';

  public loadingStaffMember = false;

  public successMessage = '';

  public serverError: number = null;
  public staffMemberNotFound = false;

  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  public ngOnDestroy() {
    this.closedCallback();
  }

  public handleSubmit() {
    this.loadingStaffMember = true;

    this.staffMemberNotFound = false;

    this.verifyPinFunction(this.pinInput)
      .then(() => {
        this.pinCallback(this.pinInput);
        this.activeModal.dismiss();
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.staffMemberNotFound = true;
          this.pinInput = '';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingStaffMember = false; });
  }

  public onPinChange() {
    this.staffMemberNotFound = false;
  }

  public canSubmitPin() {
    return (this.pinInput.length > 0) && !this.loadingStaffMember;
  }

}
